<img *ngIf="eventEntity && outcomeEntity && !isSilkLoaded" class="visibility-hidden" [src]="silkClass.spriteUrl" (load)="isSilkLoaded = true" />
<div
    [ngClass]="[
        (eventEntity.isUKorIRE ? 'with-default' : 'inter-silk') + ' ' + (!outcomeEntity.nonRunner && isSilkLoaded ? 'has-img silk-margin' : ''),
        isStreamBet ? 'silk-img-stream-bet' : 'silk-img',
    ]"
    data-crlat="raceCard.silk"
    *ngIf="outcomeEntity.racingFormOutcome?.silkName">
    <div *ngIf="isSilkLoaded" [ngStyle]="silkClass"></div>
</div>
